define('indexView',[
	"marionette"
],

function(Marionette) {

	/**
	 * The OpenAnnotate Index View.
	 * @constructor
	 */
	var IndexView = Marionette.LayoutView.extend(
	{
		template: "authentication/indexPage",
		el: "#container"
	});

	return IndexView;
});
